import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  PropsWithChildren,
} from "react";
import { usePublicOrg } from "../hooks";
import { PublicOrgDetailData } from "../interfaces/organization";
import { LOCAL_ACCESS_TOKEN_KEY } from "../utils";
import { useAuth } from "./AuthContext";
import { useAuthOrg } from "./AuthOrgContext";

interface PublicDataContextType {
  publicOrgData: any;
  loading: boolean;
  error: string | null;
}

const PublicDataContext = createContext<PublicDataContextType | undefined>(
  undefined
);

export const PublicDataProvider = ({ children }: PropsWithChildren<{}>) => {
  const { getPublicOrgData } = usePublicOrg();
  const [publicOrgData, setPublicOrgData] =
    useState<PublicOrgDetailData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();
  const { isAuthenticated: isOrgAuthenticated } = useAuthOrg();


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isAuthenticated || isOrgAuthenticated) {
          const data = await getPublicOrgData();
          setPublicOrgData(data.data || null);
        }
      } catch (err) {
        setError("Failed to fetch public account data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isAuthenticated, isOrgAuthenticated]);

  useEffect(() => {
    if (publicOrgData) {
      const faviconLink = document?.querySelector("link[rel='icon']");
      const appleTouchIconLink = document?.querySelector(
        "link[rel='apple-touch-icon']"
      );
      //@ts-expect-error
      if (faviconLink) faviconLink.href = publicOrgData?.publicFavicon;

      if (appleTouchIconLink)
        //@ts-expect-error
        appleTouchIconLink.href = publicOrgData?.publicFavicon;
    }
  }, [publicOrgData]);

  return (
    <PublicDataContext.Provider value={{ publicOrgData, loading, error }}>
      {children}
    </PublicDataContext.Provider>
  );
};

export const usePublicData = () => {
  const context = useContext(PublicDataContext);
  if (!context) {
    throw new Error("usePublicData must be used within a PublicDataProvider");
  }
  return context;
};

// Add this line to ensure the file is treated as a module
export { };
